import { Component, OnInit, ElementRef } from '@angular/core';
import { LoginService } from '../../../services/login.service';

@Component({
  host: {
      '( document: click )': 'onClickDocument( $event )'
  },
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  logo: string = '';
  isDropdownMenuVisible: boolean = false;
  dropdownMenuSelector1;
  dropdownMenuSelector2;

  constructor ( private _el: ElementRef, public loginService: LoginService ) {  }


  ngOnInit ( ) { 
    this.logo = "dist/assets/newlogo.svg";
  }


  logout( ) {
    this.loginService.logout( );
  }


  onClickDropdownButton ( ) {
      if ( !this.isDropdownMenuVisible ) this.toggleDropdownMenu( );
      return false;
  }
  toggleDropdownMenu ( ) {
      this.isDropdownMenuVisible = !this.isDropdownMenuVisible;
      return false;
  }

  onClickDocument ( event ) {

    this.dropdownMenuSelector1 = this._el.nativeElement.getElementsByClassName( 'dropdown-menu' )[0];
    this.dropdownMenuSelector2 = this._el.nativeElement.getElementsByClassName( 'dropdown-toggle' )[0];

    if ( this.isDropdownMenuVisible 
        && ( this.dropdownMenuSelector2 != event.target )
        && ( this.dropdownMenuSelector1 != event.target ) ) {

        this.toggleDropdownMenu( );
    }
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/menu/menu.component.ts